<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p style="text-align:center">Norman was born on April 1947. He left school at the age of 15 and served 9 years in the British army. He then started a job as a European HGV driver.</p><br/>
<p style="text-align:center">Norman went on to running his own business and when he sold that after many years, he was a carpenter. Then eventually, he retired.</p><br/>
<p style="text-align:center">During the pandemic and having to shield due to age and health,<br/>
he decided to write a book.</p><br/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?c2c4b046